module.exports = __webpack_public_path__ + "static/media/icon-edit.47a022f9.svg";